import { useMemo, useState } from 'react';
import type { AbgleichZeile } from './entities/Mitarbeiterabgleich';
import type { AbgleichAuswahl } from '../../features/MitarbeiterAbgleich/AbgleichTabelle';

export function useAbgleichAuswahl(zeilen: AbgleichZeile[]): AbgleichAuswahl {
  const [ausgewaehlt, setSelectedIds] = useState<Set<string>>(new Set());

  const selectedIds = useMemo(
    () => new Set(zeilen.map((z) => z.id).filter((id) => ausgewaehlt.has(id))),
    [zeilen, ausgewaehlt],
  );

  function onToggleRow(id: string, checked: boolean) {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (checked) {
        next.add(id);
      } else {
        next.delete(id);
      }
      return next;
    });
  }

  function onToggleAll(checked: boolean) {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      zeilen.forEach((z) => (checked ? next.add(z.id) : next.delete(z.id)));
      return next;
    });
  }

  return { selectedIds, onToggleAll, onToggleRow };
}
